<template>
  <div :class="{ 'form-group': options.label, 'form-row': options.horizontal }">
    <label v-if="options.label"
           :class="(options.horizontal && options.horizontal.label) ? 'col-form-label ' + options.horizontal.label : ''"
           v-html="options.label"></label>
    <div class="group-select" :class="bindClassSelect">
      <select v-bind="options" style="width: 100%;"  :disabled="disabled">
        <option
          v-if="options.selectAllText"
          :value="defaultValueSelecteAll"
          selected="selected"
        >{{ options.selectAllText }}
        </option>
        <option
          v-for="item in getDataList"
          :value="getKeyItem(item) || item"
          :key="getKeyItem(item) || item"
          :selected="checkSelected(item)"
          :disabled="item.disabled"
          :style="item._style"
          :class="item._class">
          {{ getValueItem(item) }}
        </option>
      </select>
      <div v-if="isBusy" class="loading-wrapper">
        <div class="element-loading">
          <CSpinner size="sm" name="cil-circle"/>
        </div>
      </div>
      <div class="valid-error" v-show="!(data.validator ? data.validator.isValid : true)">
        {{ data.validator ? data.validator.errorMessage : "" }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["options", "data", "disabled"],
  data() {
    return {
      isBusy: false,
      dataList: [],
      defaultValueSelecteAll: ""
    };
  },
  methods: {
    selectElement: function () {
      return this.$el.getElementsByTagName("select")[0];
    },
    getKeyItem: function (item) {
      return item[this.keyField] || item;
    },
    getValueItem: function (item) {
      return this.data.customRenderText ? this.data.customRenderText(item) : item[this.valueField] || item;
      // return item[this.valueField] || item;
    },
    checkSelected: function (item) {
      let key = this.getKeyItem(item);
      return key === this.valueSelected || key === item.selected;
    },
    updateSelectedRender: function () {
      $(this.selectElement())
        .val(this.data.model)
        .trigger("change");
    },
    getFirstOptionValue() {
      var firstElement = this.getDataList[0];
      return this.getDataList.length === 0
        ? null
        : this.options.selectAllText
          ? this.defaultValueSelecteAll
          : firstElement[this.keyField] || firstElement;
    },
    setFirstOptionSelected() {
      this.data.model = this.getFirstOptionValue();
    },
    loadData(callBack) {
      var that = this;
      that.isBusy = true;
      that.loadPromise(callBack).then(() => {
        that.isBusy = false;
      })
    },
    loadPromise(callBack) {
      return new Promise((resolve) => {
        let that = this;
        var _dataSource = this.data.source;
        if (!_dataSource) {
          console.log("Can defined dataSource!");
          return;
        }
        var _dataSubmit = _dataSource.dataSubmit
          ? _dataSource.dataSubmit()
          : null;

        if (!_dataSource.successCallback) {
          _dataSource.successCallback = function (response) {
            let dataResponse = response.data;
            if (that.$helper.validResponse(that.$router, dataResponse)) {
              var _dataResponse = _dataSource.response(dataResponse);
              that.dataList = _dataResponse;
              if (callBack) {
                callBack();
              }
            }
            // that.isBusy = false;
          }
        }
        if (!_dataSource.errorCallback) {
          _dataSource.errorCallback = function (error) {
            // that.isBusy = false;
            that.$helper.handleError(that.$router, error);
          };
        }
        resolve(_dataSource)
        this.$helper.loadDataSource(_dataSource);
      });
    },
    updateChange: function () {
      this.updateSelectedRender();
    }
  },
  computed: {
    keyField: function () {
      return this.options.keyField || "key";
    },
    hasData: function () {
      return this.getDataList.length !== 0;
    },
    valueField: function () {
      return this.options.valueField || "value";
    },
    getDataList: function () {
      return this.data.items || this.dataList;
    },
    getTextSelected: function () {
      var idSelected = this.data.model;
      if (this.data.items != null && this.data.items.length > 0) {
        for (var item of this.data.items) {
          if (item[this.keyField] == idSelected) {
            return item[this.valueField];
            break;
          }
        }
      } else {
        for (var item of this.dataList) {
          if (item[this.keyField] == idSelected) {
            return item[this.valueField];
            break;
          }
        }
      }
    },
    bindClassSelect: function () {
      let objResponse = {
        'input-valid-error': this.data.validator && !this.data.validator.isValid,
        'no-label': !(this.options && this.options.label),
      };
      if (this.options.horizontal && this.options.horizontal.input) {
        objResponse[this.options.horizontal.input] = this.options.horizontal.input;
      }
      return objResponse;
    }
  },
  created: function () {
  },
  mounted: function () {
    let that = this;
    var options =
      this.options && this.options.filter === false
        ? {minimumResultsForSearch: Infinity}
        : {};

    if (this.data.source && (this.options ? !this.options.lazyLoad : true)) {
      this.loadData();
    }
    if (this.options.customOptions === true) {
      $(this.selectElement()).select2({
        templateResult: function (data) {
          if (!data.element) {
            return data.text;
          }
          var $element = $(data.element);
          var $wrapper = document.createElement("span");
          $wrapper.style = $element[0].style.cssText;
          $wrapper.className = $element[0].className;
          $wrapper.innerText = `${data.text}`;
          return $wrapper;
        },
        minimumResultsForSearch: this.options && this.options.filter === false ? Infinity : ''
      });
    } else {
      $(this.selectElement()).select2(options);
    }

    $(this.selectElement()).change("item", function () {
      that.data.model = this.value;
    });
    if (this.hasData) {
      this.updateSelectedRender();
    }
  },
  updated: function () {
    this.updateSelectedRender();
  },
  watch: {
    "data.model": function (newValue) {
      if (newValue !== null) {
        this.updateSelectedRender();
        if (this.data.updateTrigger) {
          this.data.updateTrigger().loadData();
        }
        this.$emit("update-change", newValue);
      }
    }
  }
};
</script>
<style>
.group-select.input-valid-error .select2.select2-container .select2-selection.select2-selection--single {
  border: 1px solid #ff7070 !important;
  transition: border .3s;
}
</style>
<style scoped>
.group-select {
  position: relative;
}

.element-loading {
  left: unset;
  right: 40px;
}
</style>
